import { Box } from "@chakra-ui/react";
import Badge from "../../../components/Badge";
import Dialog from "../../../components/Dialog";
import { DialogItem } from "../../../components/Dialog/types";
import { TableData } from "../../../components/Table/types";
import { SchemaColumn } from "../../../api/types";
import { EntityId, Update } from "../../../hooks/useEntitySelection";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";


export function nestedColumnsTable(columns: SchemaColumn[] = [], update: Update): TableData {
  const actionMenu: DialogItem[] = [
    { children: "Edit", action: (id: EntityId) => update(id, "edit") },
    { children: "Delete", action: (id: EntityId) => update(id, "delete") },
  ];

  const hasDescription = columns?.some((column) => column?.description);
  const nestedTableData: { [key: string]: any } = {};

  columns.forEach((column) => {
    const isRequired = column.validations?.some((v) => v.validate === "not_blank");
    const columnData = {
      _id: column.id,
      _index: column.index,
      "Column Name": {
        raw: column.name,
        content: (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {column.parent_column_id && (
              <Box style={{ marginLeft: "-8px" }} width="24px" height="24px" display="flex" alignItems="center" justifyContent="center">
                <MdOutlineKeyboardArrowRight size={16} color="var(--color-text-soft)" />
              </Box>
            )}
            <span>{column.name}</span>
          </div>
        ),
      },
      ...(hasDescription
        ? {
            Description: {
              raw: column?.description,
              content: <span>{column?.description}</span>,
              tooltip: column?.description,
            },
          }
        : {}),
      Key: column.key,
      Required: {
        columnChildren: [] as any[],
        disableDrag: !!column.parent_column_id,
        isNested: !!column.parent_column_id,
        raw: isRequired,
        content: isRequired ? (
          <span>
            <Badge variants={["success"]}>Yes</Badge>
          </span>
        ) : (
          <span>
            <Badge variants={["neutral"]}>No</Badge>
          </span>
        ),
      },
      _actions: {
        raw: column.id,
        content: <Dialog items={actionMenu.map((e) => ({ ...e, id: column.id }))} />,
      },
    };

    if (column.parent_column_id) {
      if (nestedTableData[column.parent_column_id]) {
        nestedTableData[column.parent_column_id]?.Required?.columnChildren?.push(columnData);
      } else {
        nestedTableData[column.parent_column_id] = {
          Required: {
            columnChildren: [columnData],
          },
        };
      }
    } else {
      columnData.Required = {
        ...columnData.Required,
        columnChildren: [...(columnData.Required.columnChildren as any[]), ...(nestedTableData[column.id]?.Required?.columnChildren ?? [])],
      };
      nestedTableData[column.id] = columnData;
    }
  });

  return Object.values(nestedTableData);
}